"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioExtraMetadata = void 0;
var attached_image_1 = require("./attached-image");
var lyrics_1 = require("./lyrics");
var AudioExtraMetadata = /** @class */ (function () {
    function AudioExtraMetadata(data) {
        this.trackName = null;
        this.artist = null;
        this.albumName = null;
        this.trackNumber = null;
        this.genre = null;
        this.composer = null;
        this.year = null;
        this.images = [];
        this.lyrics = null;
        this.trackName = data.trackName;
        this.artist = data.artist;
        this.albumName = data.albumName;
        this.trackNumber = data.trackNumber;
        this.genre = data.genre;
        this.composer = data.composer;
        this.year = data.year;
        if (data.images) {
            this.images = data.images.map(function (img) {
                return new attached_image_1.AttachedImage(img);
            });
        }
        if (data.lyrics) {
            this.lyrics = new lyrics_1.Lyrics(data.lyrics);
        }
    }
    return AudioExtraMetadata;
}());
exports.AudioExtraMetadata = AudioExtraMetadata;
//# sourceMappingURL=audio-extra-metadata.js.map